export default __webpack_public_path__ + "static/media/translator-screenshot-03.4e2b7c12.png";